export const stripHtml = (html: string): string => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

export const isHTML = (text: string) => /<[a-z][\s\S]*>/i.test(text);
